import {SERVICE_ACTIONS} from "../actions/types";
import {UPDATE_SERVICES_LIST, UPDATE_SERVICES_RELATIONS} from "../actions";
import {updateCache} from "ith-redux-helpers";
import {mapObject} from "../misc/tree-handler";

const defaultState = {
	list: {},
	relations: {}
};

const getList = (old, list, unset = false) => {
	return mapObject(list, data => {
		try {
			let prev = old[data.service_id];
			if (prev ? prev.parent_id === null : unset) {
				delete prev.expanded;
				delete prev.children;
			}
			return {...prev, ...data};
		} catch (e) {
			console.error('try-catch:',e);
			return data;
		}
	});
};

export default (state = defaultState, {type, list, relations, service, expanded = false, unset, logo, service_id}) => {
	switch (type) {
		case SERVICE_ACTIONS.EXPAND:
			return {
				...state,
				list: mapObject(state.list, service => {
					return {...service, expanded};
				})
			};
		case SERVICE_ACTIONS.SET_LIST_RELATIONS:
			return {
				...state,
				list: getList(state.list, list, unset),
				relations: {...relations},
				...updateCache(UPDATE_SERVICES_LIST),
				...updateCache(UPDATE_SERVICES_RELATIONS)
			};
		case SERVICE_ACTIONS.SET_LIST:
			
			return {
				...state,
				list: getList(state.list, list),
				...updateCache(UPDATE_SERVICES_LIST)
			};
		case SERVICE_ACTIONS.UPDATE_LIST:
			const older = state.list;
			list = mapObject(older, data => {
				if ( list[data.service_id] ) {
					data = {...data, ...list[data.service_id]};
				}
				return data;
			});
			return {
				...state,
				list,
				...updateCache(UPDATE_SERVICES_LIST)
			};
			
		case SERVICE_ACTIONS.SET_RELATIONS:
			return {
				...state,
				relations: {...relations},
				...updateCache(UPDATE_SERVICES_RELATIONS)
			};
		case SERVICE_ACTIONS.SET_SERVICE:
			return {
				...state,
				list: {
					...state.list,
					[service.service_id]: {
						...state.list[service.service_id],
						...service
					}
				},
				...updateCache(UPDATE_SERVICES_LIST),
			};
		case SERVICE_ACTIONS.ADD_RELATION:
			return {
				...state,
				relations: {
					...state.relations,
					[service.parent_id]: service.service_id
				},
				...updateCache(UPDATE_SERVICES_RELATIONS)
			};
		case SERVICE_ACTIONS.SET_LOGO:
			return {
				...state,
				list: {
					...state.list,
					[service_id]: {
						...state.list[service_id],
						logo_id: logo ? logo.image_id : null,
						logo
					}
				}
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/serviceReducer.js